module.exports = __webpack_public_path__ + "img/any-num13.1bd48542.png";